import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import scriptLoader from 'react-async-script-loader'
import { connect } from 'react-redux'
import actionProps from 'actions'

import { Button } from 'react-bootstrap'
import { AddressInput } from 'components/utilities'
import { Form as BraintreeForm } from 'components/braintree'
import { Form, Field } from 'components/form'
import CreditCardForm from './_cc_form'
import { Donation, PaymentMethod, Organization, Federation } from 'resources'

const { oneOf, shape, string } = PropTypes

class UnauthenticatedDonationIndex extends React.Component {
  static propTypes = {
    params: shape({
      recipient: oneOf(['o', 'f']).isRequired,
      slug: string.isRequired,
    }).isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      authorization: null,
      recipient: null,
      donation: {},

      ready: false,
      isProcessing: false,

      cardType: 'unknown',
      validityErrors: {},
    }
  }

  componentDidMount() {
    this.doObjectRetrieve()

    PaymentMethod.authorization({
      onSuccess: this.onPaymentAuthorizationCreate,
    })

    if (window.location.pathname === '/donate/o/alpha-epsilon-pi-at-u-of-texas') {
      window.location.href = 'https://my.greekcapitalmanagement.com'
    }
  }

  isMemoRequired = () => {
    const { recipient, slug } = this.props.params
    return recipient === 'f' && slug === 'kapp-beta-gamma'
  }

  onPaymentAuthorizationCreate = ({ data: { authorization } }) => this.setState({ authorization })
  onBraintreeReady = () => this.setState({ ready: true })
  onError = errors => this.setState({ errors, isProcessing: false })

  onProcessPayment = ({ nonce }) => {
    const { donation } = this.state
    donation.braintree_nonce = nonce

    this.setState(
      {
        donation,
      },
      this.doFormSubmit
    )
  }

  onValidityErrorChange = (field, validity) => {
    const { validityErrors } = this.state

    if (validity) {
      delete validityErrors[field]
    } else {
      validityErrors[field] = true
    }

    this.setState({ validityErrors })
  }

  doObjectRetrieve = () => {
    const { slug } = this.props.params

    const resource = this.scope() === 'organization' ? Organization : Federation

    resource.lookup({
      data: { slug },
      onSuccess: ({ data }) =>
        this.setState({
          recipient: data,
        }),
      onFailure: () => this.props.actions.routePush('/'),
    })
  }

  onSuccess = ({ data }) => {
    const { recipient, slug } = this.props.params
    this.props.actions.routePush(`/donate/${recipient}/${slug}/confirmation#${data.amount}`)
  }

  onChange = e => {
    const value = e.target.value
    const name = e.target.name.split('.')[1]
    const { donation } = this.state

    donation[name] = value

    this.setState({
      donation,
      errors: null,
    })
  }

  onAddressSelect = address => {
    const { donation } = this.state

    donation.address = address

    this.setState({
      donation,
      errors: null,
    })
  }

  scope = () => (this.props.params.recipient === 'o' ? 'organization' : 'federation')

  renderTitle = () => {
    const { recipient } = this.state

    if (this.scope() === 'federation' && recipient.id === 46) {
      return <h3>Donations & Payments to {_.get(recipient, 'name')}</h3>
    }

    return this.scope() === 'organization' ? (
      <h3>
        {`Donate to ${_.get(recipient, 'federation.name')}`}
        <br />
        {`at ${_.get(recipient, 'secondary')}`}
      </h3>
    ) : (
      <h3>{`Donate to ${_.get(recipient, 'name')}`}</h3>
    )
  }

  federationName = () => {
    const { recipient } = this.state

    return this.scope() === 'organization'
      ? _.get(recipient, 'federation.name')
      : _.get(recipient, 'name')
  }

  renderBraintreeForm = () => {
    const { authorization, ready, isProcessing } = this.state
    const { cardType, errors, validityErrors } = this.state

    const disabled = !ready

    return (
      <BraintreeForm
        authorization={authorization}
        onError={this.onError}
        onBraintreeReady={this.onBraintreeReady}
        onProcessPayment={this.onProcessPayment}
        onSubmit={() => this.setState({ isProcessing: true })}
        onCardTypeChange={cType => this.setState({ cardType: cType })}
        onValidityErrorChange={this.onValidityErrorChange}
      >
        <CreditCardForm cardType={cardType} errors={errors} validityErrors={validityErrors} />

        <Button
          bsStyle="primary"
          type="submit"
          disabled={disabled || isProcessing}
          className={cx({ 'btn-loading': isProcessing }, 'p-l-1 p-r-1 m-b-1')}
        >
          Donate!
        </Button>
      </BraintreeForm>
    )
  }

  render() {
    const { donation, recipient } = this.state

    if (_.isNil(recipient)) {
      return null
    }

    const data = {
      donation: _.chain(donation)
        .merge({
          recipient_id: recipient.id,
          recipient_type: _.capitalize(this.scope()),
        })
        .value(),
    }

    console.log(recipient)

    return (
      <div className="account-wrapper account-wrapper-wide donation">
        {this.renderTitle()}

        <div className="account-form account-body m-b-2">
          <Form
            action={Donation.create}
            doSubmit={doSubmit => (this.doFormSubmit = doSubmit)}
            data={data}
            onSuccess={this.onSuccess}
            onValidationErrors={errs => this.setState({ errors: errs, isProcessing: false })}
          >
            <Field
              labelClassName="col-md-12"
              inputSize={6}
              name="donation.name"
              label={
                <span>
                  Your name <em className="m-l-1 text-muted o-75">optional</em>
                </span>
              }
              autoFocus
              className="m-b-0"
            />

            <Field
              labelClassName="col-md-12"
              inputSize={6}
              name="donation.email"
              label={
                <span>
                  Your email <em className="m-l-1 text-muted o-75">optional</em>
                </span>
              }
              className="m-b-0"
            />

            <Field
              labelClassName="col-md-12"
              inputSize={6}
              label={
                <span>
                  Your address <em className="m-l-1 text-muted o-75">optional</em>
                </span>
              }
              className="m-b-0"
            >
              <AddressInput namePrefix="donation" onAddressSelect={this.onAddressSelect} />
            </Field>

            <Field
              name="donation.amount"
              label="Amount to donate"
              labelClassName="col-md-12"
              inputSize={6}
              money
              controlClassName="m-b-0"
            />

            <Field
              name="donation.memo"
              label={
                <span>
                  Memo{' '}
                  {this.isMemoRequired() && <em className="m-l-1 text-muted o-75">optional</em>}
                </span>
              }
              labelClassName="col-md-12"
              inputSize={8}
              className="m-b-0"
            />
          </Form>

          <hr />

          {this.renderBraintreeForm()}
        </div>
      </div>
    )
  }
}

export default scriptLoader(
  `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_PLACES_API_KEY}&libraries=places`
)(connect(null, actionProps)(UnauthenticatedDonationIndex))
